import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl'
import {
    Link,
} from 'react-router-dom'
import EventBus from "../common/EventBus.js"
import GlobalHelper from '../common/GlobalHelper.jsx'
import ActionButton from "../common/button/actionbutton.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import InlineEditAddress from "../common/inline-edit/address.component.jsx"
import InlineEditContact from "../common/inline-edit/contact.component.jsx"
import InlineEditNumber from "../common/inline-edit/number.component.jsx"
import InlineEditText from "../common/inline-edit/text.component.jsx"
import InlineEditUser from "../common/inline-edit/user.component.jsx"
import LabelBadge from '../common/label/badge.component.jsx'
import LoadingSpinner from "../common/spinner/loading.component.jsx"
import CustomFieldRendering from '../custom-field/rendering.component'
import { integrationKeyLightspeed, integrationKeyQuickbooks, integrationKeyVend, integrationKeyWix } from "../integration/IntegrationConstants.jsx"
import Integrations from "../integration/Integrations.jsx"
import Guard, { Permissions } from '../role/Guard.jsx'
import { INTEGRATION_KEY } from "../state/integration/Constants"
import CustomerBalanceSummary from "./customerbalancesummary.component.jsx"
import DefaultDiscount from './defaultDiscount.component.jsx'
import OrganizationEmployeeList from "./employees.component.jsx"
import './info.scss'
import RecurringStatementOptions from './recurringstatement.component.jsx'

class CustomerInfoView extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            modal: '',
            contactId: '',
            contact: null,
            mergedContact: null,
            organization: null,
            contactType: '',
            loading: true,
            apiObject:this.props.apiObject || "contacts",
            showMorePeople: false,
            customerSelected: '',
            loyaltyBalance: '',
            paymentTerm: '',
            paymentIntegrationKey: AppContext.getPaymentIntegrationKey(),
            recurringStatement: null,
            unarchiveLoading: false,
            taxNumber: '',
            customFieldValues: {},
            customFieldDefinitions: [],
            contactOwnerName: '',
            contactOwnerId: '',
        }
        const defaultCallback = () => {
        }
        this.onChange = this.props.onChange || defaultCallback
        this.className = this.props.className || ''
        this.handleCustomerRefresh = this.handleCustomerRefresh.bind(this)
        this.unarchiveContact = this.unarchiveContact.bind(this)
        this.changeCustomFieldValues = this.changeCustomFieldValues.bind(this)
        EventBus.listen(EventBus.TopicRefreshCustomerDetails, 'customer-info-view', this.handleCustomerRefresh)
    }

    handleCustomerRefresh(event) {
        this.loadContact(event.getData().contactId)
    }



    unarchiveContact(event) {
        event.preventDefault()
        this.setState({ unarchiveLoading: true })
        return AppContext.getApiClient().put('/contacts/' + this.state.contactId + '/unarchive', {}).then(q => {
            this.setState({ unarchiveLoading: false })
            this.loadContact(q.id)
        })
    }

    componentDidMount() {
        const contactId = this.props.value || ''
        if (contactId) {
            this.loadContact(contactId)
        }
    }

    changeCustomFieldValues(value, id) {
        let customFieldValues = Object.assign({}, this.state.customFieldValues)
        let contact = Object.assign({}, this.state.contact)
        customFieldValues[id] = value
        contact.attributes.customFieldValues = customFieldValues
        this.setState({
            customFieldValues: customFieldValues,
            contact: contact,
        })
    }

    loadDefinitions() {
        AppContext.getApiClient().get('/custom-field-definitions').then(res => {
            let definitionsToApply = res.data.filter(def => def.attributes.availableFrom &&
                (def.attributes.availableFrom.includes(this.state.contactType) || !this.state.contactType))

            this.setState({
                customFieldDefinitions: definitionsToApply,
            })
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.loadContact(nextProps.value)
        }

        if (nextProps.contact) {
            this.setState({
                contact: nextProps.contact,
                customFieldValues: contact.attributes.customFieldValues,
            })
        }
    }

    loadContact(contactId, callback) {
        const next = callback || function () {
        }
        let contact = null
        AppContext.getApiClient().get(`/contacts/${contactId}`).then(r => {
            contact = r
            if (r.attributes.paymentTermId) {
                AppContext.getApiClient().get('/payment-terms/' + r.attributes.paymentTermId).then(term => {
                    this.setState({
                        paymentTerm: term.attributes.name
                    })
                })
            }
            if (r.type == 'persons' && r.attributes.organizationId) {
                return AppContext.getApiClient().get('/contacts/' + r.attributes.organizationId)
            }
            return Promise.resolve(null)
        }).then(o => {
            this.setState({
                contactId: contactId,
                contact: contact,
                contactType: contact.type,
                recurringStatement: contact.attributes.recurringStatement || null,
                loading: false,
                customFieldValues: contact.attributes.customFieldValues,
                organization: o,
                taxNumber: contact.attributes.taxNumber || '',
                contactOwnerId: contact.attributes.contactOwnerId,
            }, () => {
                this.loadDefinitions()
                if (this.state.contact.attributes.mergedToContactId &&
                    this.state.contact.attributes.mergedToContactId !== this.state.contactId) {
                    AppContext.getApiClient().get('/contacts/' + this.state.contact.attributes.mergedToContactId).then(r => {
                        this.setState({
                            mergedContact: r,
                        })
                    })
                } else {
                    this.setState({
                        mergedContact: null,
                    })
                }
                next()
            })
        })

        if (AppContext.hasFeatureIntegration(Features.LoyaltyRedemption)) {
            AppContext.getApiClient().get('/contacts/' + contactId + '/loyalty-customers').then(l => {
                this.setState({
                    loyaltyBalance: l.attributes.pointsBalance,
                })
            })
        }
    }

    getInlineContactOwner() {
        return <InlineEditUser
            editable={true}
            endPoint={`/${this.state.contactType}/${this.state.contact.id}`}
            value={''}
            field={'contactOwnerId'}
            userId={this.state.contactOwnerId}
        />
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }
        if (!this.state.contact) {
            return <div />
        }

        const existsInLightspeed = this.state.contact.attributes.externalLinks.find(l => l.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL)
        const billingAddress = this.state.contact.attributes.address || {}
        const shippingAddress = this.state.contact.attributes.shippingAddress || {}
        const numberOfBillingAddresses = this.state.contact.attributes.addresses.filter(ad => ad.addressType === 'billing').length
        const numberOfShippingAddresses = this.state.contact.attributes.addresses.filter(ad => ad.addressType === 'shipping').length

        let organization = ''
        if (this.state.organization) {
            organization = <p className="mb-2">
                <strong className="customer-info-label">
                    <FormattedMessage
                        id="customer.view.company_label"
                        defaultMessage="Company"
                    />
                </strong><br />
                <Link to={'/contacts/' + this.state.organization.id + '/details'}>
                    {this.state.organization.attributes.name}
                </Link>
            </p>
        }
        let icon = <Icon style={{
            fontSize: '35px'
        }} value={"user"} />
        let users = ''
        if (this.state.contact.type === 'organizations') {
            icon = <Icon style={{
                fontSize: '35px'
            }} value="building" />
            const people = this.state.contact.attributes.persons
            if (people && people.length > 0) {
                users = <div className="mb-2">
                    <strong className="customer-info-label">
                        <FormattedMessage
                            id="customer.view.employees_label"
                            defaultMessage="Employees"
                        />
                    </strong><br />
                    <OrganizationEmployeeList value={people} />
                </div>
            }
        }

        var contactPrimaryPhoneNumber = ''
        var contactPrimaryPhoneNumberExtension = ''
        var contactPrimaryPhoneNumberExtensionString = ''
        var contactMobilePhoneNumber = ''
        for (var i = 0; i < this.state.contact.attributes.phoneNumbers.length; i++) {
            if (this.state.contact.attributes.phoneNumbers[i]["type"] == "primary") {
                contactPrimaryPhoneNumber = GlobalHelper.formatPhoneNumber(this.state.contact.attributes.phoneNumbers[i]["phoneNumber"], this.state.contact.attributes.address.countryCode)
                if (this.state.contact.attributes.phoneNumbers[i]["extension"]) {
                    contactPrimaryPhoneNumberExtension = this.state.contact.attributes.phoneNumbers[i]["extension"]
                    contactPrimaryPhoneNumberExtensionString = " ext:" + contactPrimaryPhoneNumberExtension
                }
            }
            if (this.state.contact.attributes.phoneNumbers[i]["type"] == "mobile") {
                contactMobilePhoneNumber = GlobalHelper.formatPhoneNumber(this.state.contact.attributes.phoneNumbers[i]["phoneNumber"], this.state.contact.attributes.address.countryCode)
            }
        }

        var contactNameWithTitle = ''
        if (this.state.contact.attributes.title) {
            contactNameWithTitle += GlobalHelper.getLocalizedTitle(this.state.contact.attributes.title, AppContext.getLocale().getLanguageWithoutRegionCode()) + ' '
        }
        contactNameWithTitle += this.state.contact.attributes.name

        let defaultDiscount = this.state.contact.attributes.defaultDiscount || { attributes: {} }
        const emailIsValid = GlobalHelper.validateEmail(this.state.contact.attributes.email)

        return (
            <div className={this.className + ' row'}>
                <div className="col-12 ui-module">
                    <div className="row">
                        <div className="col-md-5 pl-4 pt-3">
                            <div className="mb-1">
                                <h2>{icon} {contactNameWithTitle}</h2>
                            </div>
                            <p className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.email_label"
                                        defaultMessage="Email"
                                    />
                                </strong><br />
                                {this.state.contact.attributes.email && emailIsValid &&
                                    <a href={'mailto:' + this.state.contact.attributes.email}>
                                        {this.state.contact.attributes.email}
                                    </a>
                                }
                                {this.state.contact.attributes.email && !emailIsValid &&
                                    <Link to={{
                                        pathname: `/contacts/${this.state.contact.id}/edit`,
                                        state: {
                                            cancelRedirectPath: `/contacts/${this.state.contact.id}/details`,
                                            saveRedirectPath: `/contacts/${this.state.contact.id}/details`,
                                            contactType: this.state.contact.type,
                                        }
                                    }} className='text-danger'>
                                        <div>
                                            <div>{this.state.contact.attributes.email}</div>
                                            <small>
                                                <Icon value={'exclamation'} className={'mr-1'} />
                                                <FormattedMessage
                                                    id="customer.view.email_invalid"
                                                    defaultMessage="This contact's email is invalid."
                                                />
                                            </small>
                                        </div>
                                    </Link>
                                }
                                {!this.state.contact.attributes.email &&
                                    <Link to={{
                                        pathname: "/contacts/" + this.state.contact.id + "/edit",
                                        state: {
                                            cancelRedirectPath: "/contacts/" + this.state.contact.id + "/details",
                                            saveRedirectPath: "/contacts/" + this.state.contact.id + "/details",
                                            contactType: this.state.contact.type,
                                        }
                                    }} className='text-danger'>
                                        <div>
                                            <small>
                                                <FormattedMessage
                                                    id="customer.view.email_missing"
                                                    defaultMessage="This contact doesn't have an email."
                                                />
                                            </small>
                                        </div>
                                    </Link>
                                }
                            </p>
                            {contactPrimaryPhoneNumber ? <p className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.phone_label"
                                        defaultMessage="Primary phone number"
                                    />
                                </strong><br />
                                <a href={"tel:" + contactPrimaryPhoneNumber + "," + contactPrimaryPhoneNumberExtension}>{contactPrimaryPhoneNumber}{contactPrimaryPhoneNumberExtensionString}</a>

                            </p> : ''}
                            {contactMobilePhoneNumber ? <p className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.phone_mobile_label"
                                        defaultMessage="Mobile phone number"
                                    />
                                </strong><br />
                                <a href={"tel:" + contactMobilePhoneNumber}>{contactMobilePhoneNumber}</a>
                            </p> : ''}
                            {organization}
                            {this.state.contact.type === 'organizations' ? <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.primary_contact_label"
                                        defaultMessage="Primary contact"
                                    />
                                </strong>
                                <div className={'w-100 mb-0'}>
                                    <InlineEditContact
                                        formClassName={'top-inherit'}
                                        contactType={'persons'}
                                        value={this.state.contact.attributes.primaryContactId}
                                        editable={true}
                                        endPoint={'/organizations/' + this.state.contact.id}
                                        field={'primaryContactId'}
                                        filters={{
                                            organizationId: this.state.contact.id,
                                        }}
                                    />
                                </div>
                            </div> : null }
                            { this.state.contact.type != 'suppliers' && <CustomerBalanceSummary
                                contactId={ this.state.contactId }
                            /> }
                        </div>
                        <div className="col-md-7 pl-5 border-left box-shadow">
                            {this.state.contact.attributes.customerType ? <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.customer_type_label"
                                        defaultMessage="Customer type"
                                    />
                                </strong>
                                <h5 className={'border-0 mb-0'}><LabelBadge
                                    value={this.state.contact.attributes.customerType} /></h5>
                            </div> : '' }
                            
                            { this.state.contact.type != 'suppliers' && <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.account_statement_automation_label"
                                        defaultMessage="Account statement automation"
                                    />
                                </strong>
                                <div className={ 'w-100 mb-0' }>
                                    <RecurringStatementOptions
                                        editable={ true }
                                        value={ this.state.recurringStatement }
                                        contactId={ this.state.contactId }
                                        contactType={ this.state.contactType }
                                        onChange={ info => {
                                            this.setState( { recurringStatement: info } )
                                        } }
                                    />
                                </div>
                                { this.state.recurringStatement && this.state.recurringStatement.attributes.enabled && this.state.recurringStatement.attributes.nextCreationDate &&
                                    <p className={ 'mb-0' }>
                                        <small>
                                            <FormattedMessage
                                                id="customer.view.next_statement_on_label"
                                                defaultMessage="Next statement on {date}"
                                                values={ {
                                                    date: <FormattedDate
                                                        year='numeric'
                                                        month='long'
                                                        day='numeric'
                                                        value={ new Date( this.state.recurringStatement.attributes.nextCreationDate ) }
                                                    />
                                                } }
                                            />
                                        </small>
                                    </p>}
                            </div> }
                            
                            { this.state.contact.type != 'suppliers' && <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.default_discount_label"
                                        defaultMessage="Default discount"
                                    />
                                </strong>
                                <div className={ 'w-100 mb-0' }>
                                    <DefaultDiscount
                                        discountType={ defaultDiscount.attributes.discountType }
                                        discountValue={ defaultDiscount.attributes.discountValue }
                                        currency={ AppContext.getCurrency() }
                                        editable={ true }
                                        enabled={ defaultDiscount.attributes.enabled }
                                        contactId={ this.state.contactId }
                                        contactType={ this.state.contactType }
                                    />
                                </div>
                            </div> }


                            {this.state.contact.type == "persons" && <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.default_credit_limit_label"
                                        defaultMessage="Credit limit"
                                    />
                                </strong>
                                <div className={'w-100 mb-0'}>
                                    <InlineEditNumber
                                        editable={Guard.isAuthorized(Permissions.BypassUpdateCreditLimit)}
                                        endPoint={`/${this.state.contactType}/${this.state.contact.id}`}
                                        field={'creditLimit'}
                                        value={this.state.contact.attributes.creditLimit}
                                        currency={AppContext.getCurrency()}
                                    />
                                </div>
                            </div>}


                             <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.tax_number_label"
                                        defaultMessage="Tax number"
                                    />
                                </strong>
                                <div className={ 'w-100 mb-0' }>
                                    <InlineEditText
                                        value={ this.state.contact.attributes.taxNumber || '-' }
                                        editable={ true }
                                        endPoint={ `/${ this.state.contactType }/${ this.state.contact.id }` }
                                        field={ 'taxNumber' }
                                        isTopInherit={ true }
                                    />
                                </div>
                            </div>

                            <div className="mb-2">
                                <div className="col px-md-0">
                                    <strong className="customer-info-label">
                                        <FormattedMessage
                                            id="customer.info_component.contact_owner_label"
                                            defaultMessage="Contact owner"
                                        />
                                    </strong>
                                    <div>
                                        <Icon value={'user'} />
                                        {this.getInlineContactOwner()}
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6">
                                    <strong className="customer-info-label">
                                        <FormattedMessage
                                            id="customer.view.billing_address_label"
                                            defaultMessage="Billing Address"
                                        />
                                    </strong>
                                    <InlineEditAddress
                                        endPoint={`/${this.state.contactType}/${this.state.contactId}`}
                                        addressEndPoint={'/contacts/' + this.state.contactId}
                                        field={'address'}
                                        formId={'contact-billing-address'}
                                        editable={true}
                                        objectType={'contact'}
                                        address={billingAddress}
                                        organizationId={this.state.contact.attributes.organizationId || ''}
                                        contactId={this.state.contactId}
                                        addressType={'billing'}
                                        contactType={this.state.contact.type}
                                        sameAddressAsOrganization={this.state.contact.attributes.sameBillingAddressAsOrganization}
                                        contactAddresses={this.state.contact.attributes.addresses}
                                    />
                                </div>
                                <div className="col-6 pr-4 text-align-right">
                                    <strong className="customer-info-label">
                                        <FormattedMessage
                                            id="customer.view.shipping_address_label"
                                            defaultMessage="Shipping Address"
                                        />
                                    </strong>
                                    <InlineEditAddress
                                        endPoint={`/${this.state.contactType}/${this.state.contactId}`}
                                        addressEndPoint={'/contacts/' + this.state.contactId}
                                        field={'address'}
                                        style={{ right: '0', left: 'auto' }}
                                        editable={true}
                                        objectType={'contact'}
                                        formId={'contact-shipping-address'}
                                        address={shippingAddress}
                                        organizationId={this.state.contact.attributes.organizationId || ''}
                                        contactId={this.state.contactId}
                                        addressType={'shipping'}
                                        contactType={this.state.contact.type}
                                        sameAddressAsOrganization={this.state.contact.attributes.sameShippingAddressAsOrganization}
                                        contactAddresses={this.state.contact.attributes.addresses}
                                    />
                                </div>
                            </div>

                            {this.state.paymentTerm && this.state.contact.type != 'suppliers' && <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.payment_term_label"
                                        defaultMessage="Payment term"
                                    />
                                </strong>
                                <br />
                                {this.state.paymentTerm}
                            </div>}

                            {this.state.contact.attributes.tax && this.state.contact.type != 'suppliers' && <div className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.default_tax_label"
                                        defaultMessage="Default tax"
                                    />
                                </strong>
                                <br />
                                {this.state.contact.attributes.tax.attributes.name}
                            </div>}
                            {users}
                            {this.state.contact.attributes.notes ? <p className="mb-2">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.notes_label"
                                        defaultMessage="Notes"
                                    />
                                </strong><br />
                                <pre>{this.state.contact.attributes.notes}</pre>
                            </p> : ''}
                            {this.state.loyaltyBalance && <div className="mb-0">
                                <strong className="customer-info-label">
                                    <FormattedMessage
                                        id="customer.view.points_balance_label"
                                        defaultMessage="Points balance"
                                    />
                                </strong><br />
                                <pre><FormattedNumber value={this.state.loyaltyBalance} /></pre>
                            </div> }
                            
                            <div className="w-100 d-flex flex-wrap">
                                <CustomFieldRendering
                                    col={ 0 }
                                    customFieldValues={ this.state.customFieldValues }
                                    customFieldDefinitions={ this.state.customFieldDefinitions }
                                    isEditable={ true }
                                    elementId={ this.state.contactId }
                                    element={ this.state.contact.type }
                                    changeCustomFieldValues={ this.changeCustomFieldValues }
                                />

                                <CustomFieldRendering
                                    col={ 1 }
                                    customFieldValues={ this.state.customFieldValues }
                                    customFieldDefinitions={ this.state.customFieldDefinitions }
                                    isEditable={ true }
                                    elementId={ this.state.contactId }
                                    element={ this.state.contact.type }
                                    changeCustomFieldValues={ this.changeCustomFieldValues }
                                />
                            </div> 
                        </div>
                        <div className="col-md-12">
                            <p className="text-align-right pr-2 mb-0">
                                {this.state.contact.type === 'organizations' && <Link to={{
                                    pathname: "/contacts/new",
                                    state: {
                                        cancelRedirectPath: "/contacts/" + this.state.contact.id + "/details",
                                        companyIdentifier: this.state.contact.id,
                                    }
                                }} className={'btn btn-outline-primary mr-2'}>
                                    <Icon value={'user-plus'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="customer.view.create_new_employee"
                                        defaultMessage="Create new employee"
                                    />
                                </Link> }
                                
                                {!this.state.contact.attributes.deletedAt && <Link to={{
                                    pathname: `/${this.state.apiObject}/${this.state.contact.id}/edit`,
                                    state: {
                                        cancelRedirectPath: `/${this.state.apiObject}/${this.state.contact.id}/details`,
                                        saveRedirectPath: `/${this.state.apiObject}/${this.state.contact.id}/details`,
                                        contactType: this.state.contact.type,
                                    }
                                }} className="text-align-right pr-2 btn btn-outline-primary ">
                                    <Icon value={'edit'} className={'mr-1'} />
                                    { this.state.contactType != "suppliers" ?
                                        <FormattedMessage
                                        id="customer.view.edit_contact_btn"
                                        defaultMessage="Edit contact"
                                        />:
                                        <FormattedMessage
                                            id="customer.view.edit_supplier_btn"
                                            defaultMessage="Edit supplier"
                                        />
                                    }
                                </Link>}
                            </p>
                            <p className="text-align-right mb-1 mt-2">
                                {
                                    this.state.contact.attributes.externalLinks.map(l => {
                                        if (![integrationKeyQuickbooks, integrationKeyVend, integrationKeyLightspeed, integrationKeyWix].includes(l.attributes.integrationKey)) {
                                            return ''
                                        }
                                        const logoImagePath = Integrations.getIntegrationLogoImagePath(l.attributes.integrationKey, true)
                                        return <a key={l.id} href={Integrations.getContactExternalUrl(l)}
                                            className={'btn btn-outline-secondary mr-2'} target={'_blank'}>
                                            <img src={logoImagePath} className={'mr-1'}
                                                style={{ width: '1rem' }} />
                                            <FormattedMessage
                                                id="customer.view.open_in_external_integration"
                                                defaultMessage="Open in {integrationName}"
                                                values={{
                                                    integrationName: Integrations.getIntegrationNameFromKey(l.attributes.integrationKey)
                                                }}
                                            />
                                        </a>
                                    })
                                }
                            </p>
                        </div>
                        {this.state.contact.attributes.deletedAt ?
                            [<div className="col-3 mt-3" key={"1"}>
                                {!this.state.mergedContact &&
                                    <ActionButton className="btn btn-sm btn-outline-primary"
                                        onClick={this.unarchiveContact}
                                        isLoading={this.state.unarchiveLoading}>
                                        <FormattedMessage
                                            id="customer.view.edit_unarchive_btn"
                                            defaultMessage="Unarchive"
                                        />
                                    </ActionButton>}
                            </div>,
                            <div className="col-md-9 mt-3" key={"2"}>
                                <p className="text-align-right text-warning mb-0">
                                    <FormattedMessage
                                        id="customer.edit_form.archived_customer_info"
                                        defaultMessage="This contact is archived and can't be found in search results."
                                    />
                                </p>
                                {(this.state.mergedContact) ?
                                    <p className="text-align-right text-warning">
                                        <FormattedMessage
                                            id="customer.edit_form.archived_customer_merged_info"
                                            defaultMessage="Merged to contact {name}"
                                            values={{
                                                name: <Link to={`/contacts/${this.state.mergedContact.id}/details`}>
                                                    {this.state.mergedContact.attributes.name}
                                                </Link>,
                                            }}
                                        />
                                    </p> : ''}
                            </div>] : ''}
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerInfoView


// WEBPACK FOOTER //
// ./src/customer/info.component.jsx